import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, ReplaySubject, Subject, Subscription, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PlantServiceService } from '../../../../../services/dashboard/solar/plant-service.service';
export function componentDestroyed(component: {
  ngOnDestroy(): void;
}): Observable<true> {
  // eslint-disable-next-line @typescript-eslint/member-ordering
  const modifiedComponent = component as {
    ngOnDestroy(): void;
    __componentDestroyed$?: Observable<true>;
  };
  if (modifiedComponent.__componentDestroyed$) {
    return modifiedComponent.__componentDestroyed$;
  }
  const oldNgOnDestroy = component.ngOnDestroy;
  const stop$ = new ReplaySubject<true>();
  modifiedComponent.ngOnDestroy = function () {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    oldNgOnDestroy && oldNgOnDestroy.apply(component);
    stop$.next(true);
    stop$.complete();
  };
  return (modifiedComponent.__componentDestroyed$ = stop$.asObservable());
}

export function untilComponentDestroyed<T>(component: {
  ngOnDestroy(): void;
}): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>) =>
    source.pipe(takeUntil(componentDestroyed(component)));
}
@Component({
  selector: 'app-plant-status',
  templateUrl: './plant-status.component.html',
  styleUrls: ['./plant-status.component.scss']
})
export class PlantStatusComponent implements OnInit, AfterViewInit, OnDestroy {
  siteId: string;
  latestIrradiance: any;
  totalACPower: any;
  totalDCPower: any;
  private subscription: Subscription;
  planStatusTimer: Observable<number>;
  private unSubscription = new Subject<void>();
  // private planStatusInterval = interval(30 * 1000);
  private alive = true;
  planStatusInterval: any;
  icon = false;
  // constructor(private plantService: PlantServiceService, private cd: ChangeDetectorRef) {
  constructor(private plantService: PlantServiceService) {
    this.subscription = new Subscription();
  }
  ngOnInit() {
    const self = this;
    this.plantService.getSolarConfigSubject().subscribe((solarConfig) => {
      console.log('SAFAG' + JSON.stringify(solarConfig));
      this.siteId = solarConfig.siteId;
      self.getData();
      self.subscription = timer(30, 30 * 1000).subscribe(() => {
        if (self.alive) {
          self.getData();
        } else {
          if (self.subscription) {
            self.subscription.unsubscribe();
          }
        }
      });
    });
  }
  private getData = () => {
    this.plantService
      .getLatestIrradianceDataOfSite(this.siteId, true)
      .subscribe((data) => {
        this.latestIrradiance = data.irradianceValue;
        this.totalACPower = data.totalACPower;
        this.totalDCPower = data.totalDCPower;
      });
  };
  ngAfterViewInit() {}
  ngOnDestroy() {
    const t = this;
    if (t.subscription) {
      t.alive = false;
      t.subscription.unsubscribe();
    }
  }
  public click = () => {
    this.icon = !this.icon;
  };
}
